import React from 'react';
import moment from 'moment';

import { useNavigate } from "react-router-dom";
import { Box, CardHeader, Grid, List, ListItem, Typography, useTheme, IconButton } from '@mui/material';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useDispatch } from 'react-redux';

import { FROM_NUMBER, MAX_MESSAGE_LENGTH_ON_DISPLAY } from '../../constants'

export default function MessageList({
    messages,
    alertSound,
    activeNumber,
    changeToNumber
}) {
    const theme = useTheme();
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <Box sx={{ width: "100%", overflowY: 'auto', mt: '7px' }}>
            <Grid
                container
                direction="column"
                alignItems="center"
                justify="center"
                sx={{
                    background: theme.palette.primary.dark,
                }}
            >
                <List id="list"
                    sx={{
                        height: '100%',
                        width: '100%',
                        maxHeight: '100%',
                    }}>
                    {
                        messages?.map((element, index) => {
                            let messageToDisplay = element.body
                            if (moment(element.createdAt).isAfter(moment().subtract(2, 'seconds'))) {
                                alertSound.play()
                            }

                            // if message starts with a link
                            if (messageToDisplay.startsWith('http')) {
                                messageToDisplay = messageToDisplay.substring(messageToDisplay.indexOf(' '), messageToDisplay.length)
                            }

                            /* shorten message when its displayed */
                            if (messageToDisplay.length > MAX_MESSAGE_LENGTH_ON_DISPLAY) {
                                messageToDisplay = messageToDisplay.substring(0, MAX_MESSAGE_LENGTH_ON_DISPLAY - 3) + '...'
                            }
                            return (
                                <ListItem
                                    key={index}
                                    onClick={() =>
                                        dispatch(
                                            changeToNumber(element.from === FROM_NUMBER ? element.to : element.from)
                                    )}
                                    sx={{
                                        width: '100%',
                                        maxWidth: '100%',
                                        background: activeNumber === element.to || activeNumber === element.from ?
                                        theme.palette.secondary.main : ''
                                    }}>
                                    {moment(element.createdAt).isAfter(moment().subtract(1, 'minutes')) && (
                                        <CircleNotificationsIcon fontSize='small' color='error' />
                                    )}
                                    <CardHeader
                                        title={<Typography gutterBottom variant="h6" component="h4">
                                            {element.name}
                                        </Typography>}
                                        subheader={<Typography wrap gutterBottom variant="p" component="p">
                                            {messageToDisplay}
                                        </Typography>}
                                        subheaderTypographyProps={{
                                            wordWrap: 'break-word',
                                        }}
                                        sx={{
                                            width: '90%',
                                            maxWidth: '90%',
                                            background: 'transparent',
                                        }}
                                    />
                                    {!element.contactExists && (
                                        <IconButton 
                                        color={activeNumber === element.to || activeNumber === element.from 
                                        ? 'primary' : 'secondary'}
                                        onClick={()=> navigate(`/contacts?number=${element.from === FROM_NUMBER ? element.to : element.from}`)}>
                                            <AddCircleOutlineIcon fontSize='small'/>
                                        </IconButton>
                                    )}
                                </ListItem>
                            )
                        })
                    }
                </List>
            </Grid>
        </Box>
    )
}